/**
 * This provides a wrapper around a usual React-Router-DOM route.
 * A private route prevents an unauthenticated user to access the respective component.
 * It can be used in exactly the same manner as a usual Route component.
 *
 * Example:
 *   Unauthenticated user accesses the path '/admin/users'
 *   A forwarding to the sign-in pages occurs
 *
 * This way, we do easy in non-redundant client-side authentication checks.
 * However, the backend needs to perform the checks in addition to prevent attacks.
 *
 * Flow:
 *  - If the authentication status changed, the FirebaseAuthProvider will recognize it and update the child-components
 *  - As everything is wrapped in the FirebaseAuthProvider, this will also update the private routes included there
 */

import React, {useContext} from "react";
import {Redirect, Route} from "react-router-dom";

import {FirebaseAuthContext} from "components/commons/firebase/FirebaseAuthProvider";


const ProtectedRoute = ({component: RouteComponent, allowedRoles, ...rest}) => {
    const {signedInUser, signedInUserRole} = useContext(FirebaseAuthContext);

    /*
    If authenticated, the user is returned to the requested route.
    Otherwise, a redirection to the sign-in section occurs, where the user can authenticate again.
     */
    if (!!signedInUser && allowedRoles.includes(signedInUserRole)) {
        console.log('"' + rest?.location?.pathname + '" for role "' + signedInUserRole + '" allowed (protected)')
        return <Route {...rest} render={routeProps => <RouteComponent {...{...routeProps, ...rest}} />}
        />
    }

    console.log('"' + rest?.location?.pathname + '" for role "' + signedInUserRole + '" NOT allowed (protected)')

    // Otherwise return to '/' (if signed in, it will forward the user to the respective landing page
    // if not signed in the user will be forwarded to the sign in page)
    return <Route {...rest} render={routeProps => <Redirect to={"/"}/>}
    />
};

export default ProtectedRoute